import ProgressBar from "../../components/ProgressBar";
import StatusBlock from "../../components/StatusBlock";
import styles from './StationProductivity.module.css';

function StationProductivity({locationStatus, userConfig, loading}) {
  return (
    <div className={styles.gridLayout}>
      <StatusBlock title='Panels Cut Today - Station Target' loading={loading}>
        <p>
          {!loading && <span className={styles.pendingCount + ' ft-28'}>{(userConfig.target?.beamsaw - locationStatus.location_count < 0) ? 0 : userConfig.target?.beamsaw - locationStatus.location_count}</span>}
          <span className={styles.pendingText + ' ft-16'}>Pending Panels</span>
        </p>
        <div className={'line ' + styles.mb8}></div>
        {!loading && <ProgressBar showText={true} fraction={locationStatus.location_count} total={userConfig.target?.beamsaw}></ProgressBar>}
      </StatusBlock>
      {/* <StatusBlock title='Boards Cut Today' loading={loading}>
        <p>
          <span className={styles.pendingCount + ' ft-28'}>10</span>
          <span className={styles.pendingText + ' ft-16'}>/20</span>
        </p>
        <p>All Boards Available</p>
      </StatusBlock>
      <StatusBlock title='Manually Added Panels' loading={loading}>
        <p><span className={styles.pendingCount + ' ft-28'}>03</span></p>
        <a>View Panels</a>
      </StatusBlock> */}
    </div>
  );
}

export default StationProductivity;
